module.exports = __webpack_public_path__ + "img/DE05888.cd2efb6d.png";